import { render } from "./Graphics.vue?vue&type=template&id=0b27ca42&scoped=true"
import script from "./Graphics.vue?vue&type=script&lang=js"
export * from "./Graphics.vue?vue&type=script&lang=js"

import "./Graphics.vue?vue&type=style&index=0&id=0b27ca42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b27ca42"]])

export default __exports__